<template>
	<div v-for="perkConfig in perkConfigs" :key="perkConfig.title" class="field border-1 border-gray-300 p-2 border-round shadow-1">
		<div class="flex m-0 p-0">
			<h3 class="text-gray-700 mb-0 pb-0 w-fit">{{perkConfig.title}}</h3>
			<div class="flex flex-wrap ml-auto text-center ">
				<label for="" class="mx-auto w-full ">{{perkConfig.enabled ? 'Enabled' : 'Disabled'}}</label>
				<InputSwitch v-model="perkConfig.enabled" class="mx-auto p-0"></InputSwitch>
			</div>
		</div>
			<p class="pb-3 m-0 text-xs pt-1">{{perkConfig.help}}</p>
			<div v-if="perkConfig.enabled && perkConfig.title == 'Signup Perks'" >
				<div v-for="config,i  in perkConfig.configs" :key="config" class="field border-1 p-2 border-gray-300 rounded shadow-1">
					<div class="flex justify-between">
						<p>Perk {{i + 1}}</p>
						<Button @click="removeSignupPerk(i)" class="ml-auto h-2rem p-button-danger">Remove</Button>
					</div>
					<div class="p-inputgroup">
						<Dropdown v-model="config.perkId.id" :options="perks" filter optionLabel="title" optionValue="id" :optionDisabled="(perk) => !perk.enabled" placeholder="Select Perk" />
					</div>

					<label v-if="!config.isFromNightPay" style="font-size: 90%; margin-bottom: 2px" class="mt-3">Venue</label>
					<div  v-if="!config.isFromNightPay" class="p-inputgroup">
						<Dropdown v-model="config.venueId" :options="venues" filter optionLabel="name" optionValue="venueId" placeholder="All" />
					</div>

					<label  style="font-size: 90%; margin-bottom: 2px" class="mt-3">Is from NightPay</label>
					<div class="p-inputgroup">
						<InputSwitch v-model="config.isFromNightPay" />
					</div>

					<label style="font-size: 90%; margin-bottom: 2px" class="mt-3">Quantity</label>
					<InputNumber v-model="config.quantity" style="width: 200px" />


					<label style="font-size: 90%; margin-bottom: 2px" class="mt-3">Expires</label>
					<InputSwitch v-model="config.expires" />

					<div v-if="config.expires">
						<label style="font-size: 90%; margin-bottom: 2px" class="mt-2">Expires in</label>
						<div class="p-inputgroup">
							<InputNumber v-model="config.expire" style="max-width: 200px" />
							<Dropdown
								v-model="config.expireType"
								:options="durationTypes"
								optionLabel="title"
								optionValue="id"
								placeholder="Select duration"
								style="margin-left: 8px; max-width: 200px"
							/>
						</div>
						<div class="my-2">or</div>
						<div class="mt-1">
							<label style="font-size: 90%; margin-bottom: 2px" class="mt-2">Expires at date (overrules expires in)</label>
							<div>
							<Calendar 
							:showIcon="true"
							v-model="config.expireDate"
							placeholder="Select date"
							/>
							</div>
						</div>
					</div>

					<!-- Time-based Redemption Controls -->
					<div class="mt-3 p-2 border-1 border-gray-200 border-round">
						<label style="font-size: 90%; margin-bottom: 8px; font-weight: 600;" class="block">🕒 Redemption Time Control</label>
						
						<div class="field mb-2">
							<label style="font-size: 85%; margin-bottom: 4px;" class="block">Limit perk redemption hours</label>
							<div class="flex align-items-center">
								<InputSwitch 
									v-model="config.perkRedemptionTimeControl.isRedemptionTimeLimited" 
									@change="onRedemptionTimeLimitedChange(config)"
								/>
								<span class="ml-2" style="font-size: 80%;">
									{{ config.perkRedemptionTimeControl.isRedemptionTimeLimited ? 'Enabled' : 'Disabled' }}
								</span>
							</div>
						</div>

						<div v-if="config.perkRedemptionTimeControl.isRedemptionTimeLimited" class="grid grid-cols-2 gap-2">
							<div class="col-span-1">
								<label style="font-size: 85%; margin-bottom: 4px;" class="block">🔒 Locked from</label>
								<Calendar
									v-model="config.perkRedemptionTimeControl.lockedFromTimeDate"
									timeOnly
									hourFormat="24"
									placeholder="e.g., 13:00"
									@date-select="onTimeChange(config, 'lockedFromTime', $event)"
									style="width: 100%;"
								/>
								<small class="text-xs text-gray-500">
									Time when perk becomes unavailable for redemption in {{ detectedTimeZone }}
								</small>
							</div>

							<div class="col-span-1">
								<label style="font-size: 85%; margin-bottom: 4px;" class="block">🔓 Unlocked at</label>
								<Calendar
									v-model="config.perkRedemptionTimeControl.unlockedAtTimeDate"
									timeOnly
									hourFormat="24"
									placeholder="e.g., 14:00"
									@date-select="onTimeChange(config, 'unlockedAtTime', $event)"
									style="width: 100%;"
								/>
								<small class="text-xs text-gray-500">
									Time when perk becomes available again in {{ detectedTimeZone }}
								</small>
							</div>

							<div class="col-span-2 mt-2">
								<label style="font-size: 85%; margin-bottom: 4px;" class="block">🌍 Timezone</label>
								<InputText
									v-model="config.perkRedemptionTimeControl.timeZoneId"
									readonly
									style="width: 100%;"
								/>
								<small class="text-xs text-gray-500">
									Timezone for the redemption time control (auto-detected)
								</small>
							</div>
						</div>
					</div>
				</div>	
				<div>
					<Button  @click="addSignupPerk"> Add perk</Button>
				</div>
			</div>

			<div v-if="perkConfig.enabled && perkConfig.title != 'Signup Perks'" class="field">
					
					<div class="p-inputgroup">
						<Dropdown v-model="perkConfig.perkId.id" :options="perks" filter optionLabel="title" optionValue="id" :optionDisabled="(perk) => !perk.enabled" placeholder="Select Perk" />
					</div>

					<label v-if="!perkConfig.isFromNightPay" style="font-size: 90%; margin-bottom: 2px" class="mt-3">Venue</label>
					<div  v-if="!perkConfig.isFromNightPay" class="p-inputgroup">
						<Dropdown v-model="perkConfig.venueId" :options="venues" filter optionLabel="name" optionValue="venueId" placeholder="All" />
					</div>

					<label  style="font-size: 90%; margin-bottom: 2px" class="mt-3">Is from NightPay</label>
					<div class="p-inputgroup">
						<InputSwitch v-model="perkConfig.isFromNightPay" />
					</div>

					<label style="font-size: 90%; margin-bottom: 2px" class="mt-3">Quantity</label>
					<InputNumber v-model="perkConfig.quantity" style="width: 200px" />


					<label style="font-size: 90%; margin-bottom: 2px" class="mt-3">Expires</label>
					<InputSwitch v-model="perkConfig.expires" />

					<div v-if="perkConfig.expires">
						<label style="font-size: 90%; margin-bottom: 2px" class="mt-2">Expires in</label>
						<div class="p-inputgroup">
							<InputNumber v-model="perkConfig.expire" style="max-width: 200px" />
							<Dropdown
								v-model="perkConfig.expireType"
								:options="durationTypes"
								optionLabel="title"
								optionValue="id"
								placeholder="Select duration"
								style="margin-left: 8px; max-width: 200px"
							/>
						</div>
						<div class="my-2">or</div>
						<div class="mt-1">
							<label style="font-size: 90%; margin-bottom: 2px" class="mt-2">Expires at date (overrules expires in)</label>
							<div>
							<Calendar 
							:showIcon="true"
							v-model="perkConfig.expireDate"
							placeholder="Select date"
							/>
							</div>
						</div>
					</div>
				
			</div>
		</div>
		<Button class="flex-1 mt-3 w-full" @click="onSave" :label="'Update'" :icon="'pi pi-cloud-upload'" />

</template>

<script>
import { onMounted, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'primevue/usetoast';


export default {
	emits: ['onAction'],
	props: ['context'],
	setup(props, {emit}) {
		
		const store = useStore();

		const perkConfigs = ref(props.context)

		var perks = ref([])
		var venues = ref([])
		const toast = useToast();

		// Get the user's timezone
		const detectedTimeZone = computed(() => {
			return Intl.DateTimeFormat().resolvedOptions().timeZone;
		});

		// Get current local time for display
		const currentLocalTime = computed(() => {
			const now = new Date();
			const hours = now.getHours().toString().padStart(2, '0');
			const minutes = now.getMinutes().toString().padStart(2, '0');
			return `${hours}:${minutes}`;
		});

		const durationTypes = ref([
			{
				id: 'Day',
				title: 'day(s)',
			},
			{
				id: 'Week',
				title: 'week(s)',
			},
			{
				id: 'Month',
				title: 'month(s)',
			},
			{
				id: 'Year',
				title: 'year(s)',
			},
		]);


		function onSave(){
			if((perkConfigs.value[1].enabled && !perkConfigs.value[1].perkId?.id ))
			{
					toast.add({
					severity: 'error',
					summary: 'Error',
					detail: 'Could not update subscription perk configurations' ,
					life: 3000,
				});
				return
			}
			
			console.log("SAVE: ", perkConfigs.value)
			emit('onAction', perkConfigs.value);
		}
	
		function addSignupPerk(){
			perkConfigs.value[0].configs.push(
				{
					perkId: {id: ""},
					venueId: {id: ""},
					isFromNightPay: false,
					quantity: 1,
					expires: false,
					expire: 1,
					expireType: "month",
					perkRedemptionTimeControl: {
						isRedemptionTimeLimited: false,
						lockedFromTime: null,
						unlockedAtTime: null,
						lockedFromTimeDate: null,
						unlockedAtTimeDate: null,
						timeZoneId: detectedTimeZone.value
					}
				}
			)
		}

		function removeSignupPerk(index){
			perkConfigs.value[0].configs?.splice(index, 1)
		}

		function parseTimeToDate(timeString) {
			if (!timeString) return null;
			const [hours, minutes] = timeString.split(':').map(num => parseInt(num, 10));
			
			// Create a date object in local time
			const date = new Date();
			date.setHours(hours, minutes, 0, 0);
			
			return date;
		}

		function formatTimeFromDate(date) {
			if (!date) return null;
			
			// Get time in local timezone
			const hours = date.getHours().toString().padStart(2, '0');
			const minutes = date.getMinutes().toString().padStart(2, '0');
			const seconds = "00"; // Always use 00 for seconds
			
			return `${hours}:${minutes}:${seconds}`; // TimeSpan format for JSON.NET
		}

		function onRedemptionTimeLimitedChange(config) {
			if (!config.perkRedemptionTimeControl.isRedemptionTimeLimited) {
				// Clear time restrictions when disabled
				config.perkRedemptionTimeControl.lockedFromTime = null;
				config.perkRedemptionTimeControl.lockedFromTimeDate = null;
				config.perkRedemptionTimeControl.unlockedAtTime = null;
				config.perkRedemptionTimeControl.unlockedAtTimeDate = null;
			} else {
				// Set default timezone when enabling
				config.perkRedemptionTimeControl.timeZoneId = detectedTimeZone.value;
			}
		}

		function onTimeChange(config, timeType, event) {
			const timeString = formatTimeFromDate(event);
			if (timeType === 'lockedFromTime') {
				config.perkRedemptionTimeControl.lockedFromTime = timeString;
			} else if (timeType === 'unlockedAtTime') {
				config.perkRedemptionTimeControl.unlockedAtTime = timeString;
			}
		}

		function initializeRedemptionTimeControl(config) {
			if (!config.perkRedemptionTimeControl) {
				config.perkRedemptionTimeControl = {
					isRedemptionTimeLimited: false,
					lockedFromTime: null,
					unlockedAtTime:null,
					lockedFromTimeDate: null,
					unlockedAtTimeDate: null,
					timeZoneId: detectedTimeZone.value
				};
			} else {
				// Initialize Date objects for time pickers from string times
				if (config.perkRedemptionTimeControl.lockedFromTime) {
					config.perkRedemptionTimeControl.lockedFromTimeDate = parseTimeToDate(config.perkRedemptionTimeControl.lockedFromTime);
				}
				if (config.perkRedemptionTimeControl.unlockedAtTime) {
					config.perkRedemptionTimeControl.unlockedAtTimeDate = parseTimeToDate(config.perkRedemptionTimeControl.unlockedAtTime);
				}
				// Ensure timezone is set
				if (!config.perkRedemptionTimeControl.timeZoneId) {
					config.perkRedemptionTimeControl.timeZoneId = detectedTimeZone.value;
				}
			}
		}

		async function loadRequiredData(){
			

			await store.dispatch( 'perks/ensurePerkListItems')
			const loadedPerks = store.getters['perks/perkListItems'];
			perks.value = loadedPerks
		
			await store.dispatch('venues/ensureVenueListItems');
			const loadedVenues = store.getters['venues/venueListItems'];
			venues.value = [{venueId: null, name: "All"}, ...loadedVenues]

			// Initialize redemption time control for existing configs
			perkConfigs.value.forEach(perkConfig => {
				if (perkConfig.configs) {
					perkConfig.configs.forEach(config => {
						initializeRedemptionTimeControl(config);
					});
				} else {
					initializeRedemptionTimeControl(perkConfig);
				}
			});

		}


		onMounted(()=>{
			loadRequiredData();
		})
		return {
			perkConfigs,
			onSave,
			addSignupPerk,
			removeSignupPerk,
			onRedemptionTimeLimitedChange,
			onTimeChange,
			detectedTimeZone,
			currentLocalTime,
			venues,
			perks,
			durationTypes

		};
	},
};
</script>
